import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
export class CrusherDeviceBoxAdapter {
    type = "audio-effect";
    accepts = "audio";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            crush: this.#parametric.createParameter(box.crush, ValueMapping.unipolar(), StringMapping.percent(), "Crush"),
            bits: this.#parametric.createParameter(box.bits, ValueMapping.linearInteger(1, 16), StringMapping.numeric(), "Bits"),
            boost: this.#parametric.createParameter(box.boost, ValueMapping.linear(0.0, 24.0), StringMapping.decible, "Boost"),
            mix: this.#parametric.createParameter(box.mix, ValueMapping.exponential(0.001, 1.0), StringMapping.percent(), "Mix")
        };
    }
}
